import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel
initMetaPixel();
render(<App data-id="element-301" />, document.getElementById('root'));